import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePCrmInvoiceCategory, PCrmInvoiceCategory } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<PCrmInvoiceCategory>
      useData={usePCrmInvoiceCategory}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
